"use client";

import { Typography } from "antd/lib";
import { useTranslations } from "next-intl";
import { useLanguageContext } from "@/context/LanguageContext";

export const ViewMoreNews: React.FC<{ className?: string; category?: string; source?: string }> = ({
  className,
  category,
  source,
}) => {
  const t = useTranslations("news");
  const { language } = useLanguageContext();

  return (
    <Typography.Link
      href={`/${language}/news/search${category ? `?category=${category}` : ""}${source ? `?source=${source}` : ""}`}
      className={className}
    >
      {t("View_more_news")}
    </Typography.Link>
  );
};
